import React from "react";
import { useTranslation } from "react-i18next";

type HalfCircleRedProps = {
  size?: number;
  strokeWidth?: number;
  number?: number;
};

const HalfCircleRed: React.FC<HalfCircleRedProps> = ({
  size = 200,
  strokeWidth = 20,
  number,
}) => {
  const { t } = useTranslation();
  const radius = (size - strokeWidth) / 2;
  const center = size / 2;

  return (
    <div className="shadow-custom-light bg-white rounded-2xl p-6 flex flex-col items-center">
      <svg width={size} height={radius + strokeWidth}>
        {/* نصف الدائرة الأحمر */}
        <path
          d={`M ${center - radius} ${radius + strokeWidth / 2} 
              A ${radius} ${radius} 0 0 1 ${center + radius} ${radius + strokeWidth / 2}`}
          fill="none"
          stroke="#E55F5F"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />

        {/* الرقم في منتصف نصف الدائرة */}
        <text
            x={center}
            y={center / 1.2}
            textAnchor="middle"
            className="text-[32px] font-black fill-Black"
            >
            {number?.toFixed(2)} {t("min")}
            </text>
      </svg>

      {/* النص تحت نصف الدائرة */}
    <p className="text-[14px] font-medium text-Black mt-2 text-center">
        {t("averagePrepTime")}
    </p>
    </div>
  );
};

export default HalfCircleRed;
